import type { ReactNode } from "react";
import { TableScroll } from "@/components/layout/ContentBlock";

export type ComparePane = {
  label: string;
  caption?: string;
  children: ReactNode;
};

/** Side-by-side comparison of two concepts (UPC vs EAN, 1D vs 2D, plain vs
 *  GS1 Data Matrix), rendered as a two-column table so it can sit directly
 *  inside #mv-content: the pane labels are the header cells, each pane's
 *  body and caption fill one cell. Scrolls horizontally on narrow screens. */
export function Compare({ panes }: { panes: [ComparePane, ComparePane] }) {
  return (
    <TableScroll>
      <table>
        <thead>
          <tr>
            {panes.map((p) => (
              <th key={p.label} scope="col">
                {p.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            {panes.map((p) => (
              <td key={p.label}>
                {p.children}
                {p.caption && <p>{p.caption}</p>}
              </td>
            ))}
          </tr>
        </tbody>
      </table>
    </TableScroll>
  );
}
